import React from "react";
import { Button } from "../ui/button";
import { OFFER_ANCHOR, CTA_TEXT } from "../../data/mock";

const HowItWorks = () => {
  return (
    <section className="section-pad bg-pink-50/70">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block text-[11px] md:text-xs font-bold tracking-widest text-pink-600 uppercase">Passo a passo</span>
          <h2 className="mt-2 font-serif-display font-black text-2xl md:text-5xl text-pink-700">Como funciona</h2>
          <p className="mt-3 text-pink-900/70 text-sm md:text-base">
            Em apenas <strong>3 passos simples</strong> você começa a encantar suas clientes.
          </p>
        </div>

        <div className="mt-6 md:mt-10 flex justify-center">
          <div className="relative max-w-md md:max-w-lg w-full">
            <div className="absolute -inset-4 bg-gradient-to-b from-pink-200/60 to-rose-200/60 blur-2xl opacity-60 rounded-3xl" />
            <img
              src="/site-images/how-it-works.png"
              alt="Como funciona: 1. Escolha a arte  2. Imprima  3. Monte suas embalagens"
              className="relative w-full h-auto drop-shadow-xl"
              loading="lazy"
            />
          </div>
        </div>

        <div className="mt-6 md:mt-10 text-center">
          <a href={OFFER_ANCHOR}>
            <Button size="lg" className="w-full sm:w-auto bg-gradient-to-b from-pink-500 to-rose-600 hover:from-pink-600 hover:to-rose-700 text-white font-bold px-6 md:px-8 py-5 rounded-full shadow-lg text-sm md:text-base">
              👉 {CTA_TEXT}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
